const sharps = ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B"];
const flats = ["C", "D♭", "D", "E♭", "E", "F", "G♭", "G", "A♭", "A", "B♭", "B"];

export function createQuestions(notes, spelling, previous = null, random = Math.random) {
  const questions = [];
  for (let pitch = 0; pitch < 12; pitch++) {
    if (!notes[pitch]) continue;
    if (spelling === 1 || spelling === 2) questions.push([pitch, sharps[pitch]]);
    if (spelling === 0 || spelling === 2) questions.push([pitch, flats[pitch]]);
  }
  for (let i = questions.length - 1; i > 0; i--) {
    const j = Math.floor(random() * (i + 1));
    [questions[i], questions[j]] = [questions[j], questions[i]];
  }
  // Compare the whole question: enharmonic spellings remain distinct choices.
  // Pick uniformly among alternatives, without changing the batch's vocabulary.
  if (previous && questions[0]?.[0] === previous[0] && questions[0]?.[1] === previous[1]) {
    const alternatives = questions.map((question, index) => index).filter(index =>
      questions[index][0] !== previous[0] || questions[index][1] !== previous[1]);
    if (alternatives.length) {
      const j = alternatives[Math.floor(random() * alternatives.length)];
      [questions[0], questions[j]] = [questions[j], questions[0]];
    }
  }
  return questions;
}

export const fretCount = tuning => Math.max(...tuning) + 12;
export function notePitch(tuning, base, string, fret) {
  return base + fret + tuning.slice(0, string).reduce((sum, interval) => sum + interval, 0);
}
export const matchesQuestion = (pitch, question) => Number.isInteger(pitch) &&
  !!question && pitch % 12 === question[0];

// Use Both changes presentation only; never rebuild or reweight the queue here.
// Natural questions and exploration retain the existing sharp-label default.
export function diagramSpelling(mode, training, question) {
  if (mode !== 2) return mode;
  return training && question?.[1].includes("♭") ? 0 : 1;
}
